// extracted by mini-css-extract-plugin
module.exports = {"image":"Illustration_image__kwPT7"};